import { DriverMapping as DriverMappingType } from '@amzn/allocations-service';

export interface DriverMapping extends DriverMappingType {
  allocationFunction?: string;
  primaryDriver?: string;
  secondaryDriver?: string;
  fallbackDriver?: string;
}
